import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DashboardStateInterface {
  menuOrder: { id: number; value: string }[];
}

const initialDashboardState: DashboardStateInterface = {
  menuOrder: [],
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialDashboardState,
  reducers: {
    setDashboardMenuOrder: (
      state,
      action: PayloadAction<{ id: number; value: string }[]>
    ) => {
      state.menuOrder = action.payload;
    },
  },
});

export const { setDashboardMenuOrder } = dashboardSlice.actions;

export default dashboardSlice.reducer;
